import { useState } from "react";
import { deleteOrganizationUser } from "../../../../Api/Network";
import { Globals } from "../../../../Global";
import DeleteIcon from "../../IconsCode/DeleteIcon";
import Loading from "../../SubDashboard/Loading/Loading";


function DeleteUser({ user, close, openError, openSuccess, onDeleted }) {

    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        close(false);
    }

    const handleDelete = async () => {
        setLoading(true);
        try {
            const data = await deleteOrganizationUser({ token: Globals.token, id: user.id })
            if (data.status === 200) {
                console.log("yessssssss", data.status)
                handleClose()
                openSuccess(`کاربر ${user.id} با موفقیت حذف شد.`)
                onDeleted(user.id);
            } else {
                openError(data.message || "حذف کاربر با خطا مواجه شد.");
            }
        } catch (err) {
            openError(err.message || "حذف کاربر با خطا مواجه شد.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40" onClick={handleClose}></div>
            <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary-100 rounded-lg px-14 py-14 ">
                <div className="flex flex-col items-center">
                    <div className="bg-red-100 rounded-full p-4 flex ">
                        <DeleteIcon color="#DE0613" size="40" />
                    </div>
                    <p className="mt-2 font-bold rtol">حذف &nbsp; {user.name}</p>
                    <p className="rtol my-4 text-slate-700">آیا از حذف &nbsp; <span className="underline">{user.id}</span> &nbsp; {user.userType} &nbsp; اطمینان دارید؟ </p>
                    <div className="flex flex-row-reverse justify-between gap-8 mt-6 w-full">
                        <button onClick={handleDelete} className="bg-redCustom-500 flex-1 rounded-lg text-white p-2">حذف</button>
                        <button onClick={handleClose} className="border border-primary-500 flex-1 rounded-lg text-primary-500 p-2">لغو</button>
                    </div>
                </div>
            </div>
            {loading && <Loading />}
        </>
    )
}
export default DeleteUser;